import assetPath from '/app/xinglets/profile/main-logged-out/src/xing-id/cover-image/assets/premium_984.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')